import React from 'react';
import MediaSelector from '../editor/fields/MediaSelector';
import * as Comp from '../editor/PuckComps';
import * as Opt from '../editor/Helpers';
import ColorSelector from '../editor/fields/ColorSelector';

class ColumnsMasonry extends React.Component {
    constructor(props) {
        super(props);
    }

    loadItem = (i, index) => {
        let cardStyle = {}
        if(i.cardHeight) { cardStyle.minHeight = i.cardHeight }
        if(i.backgroundImage) { 
            cardStyle.background = `url(${i.backgroundImage}) center center no-repeat`

            cardStyle.backgroundSize = 'cover'
        }
        const ColumnMasonrySlot = this.props[String(index)]
        const columnContent = Array.isArray(ColumnMasonrySlot) ?ColumnMasonrySlot : [];
        return <div className={`rounded-[20px] p-[20px] mb-[30px] ${!i.backgroundImage && 'bg-'+i.cardBackgroundColor}`} style={cardStyle}>
             {window.location.pathname.includes('editor') && <ColumnMasonrySlot disallow={["Columns", "ColumnsMasonry", "Container", "ContentSectionLayout", "CustomerTestimonials", "FAQ", "FeaturesLayout", "HeroMetric", "ImgContentCard", "Metrics", "PricingSection", "TestimonialWithImage", "Posts"]}/>}
            {columnContent.map((comp, index) => {
                // Loop over all the components for that column and render them within
                let Component = Comp[comp.type]
                if (!Component) {
                        console.warn(`Nested component type "${comp.type}" not found for Masonry column ${index}.`);
                        return null;
                    }
                return <Component key={index} {...comp.props} />;
            })}
        </div>
    }

    getColumnBoundaries = (n, numCols) => {
        if (numCols === 2) return [0, Math.round(n / 2), n]
        const sizeThree = Math.round(n / 3)
        const remaining = Math.ceil(n / 3) - sizeThree
        return [0, sizeThree + remaining, sizeThree * 2 + remaining, n]
    }

    render() {
        const items = this.props.columns
        const numCols = this.props.columnLength
        const boundaries = this.getColumnBoundaries(items.length, numCols)
        const colWidth = numCols === 2 ? 'w-1/2' : 'w-1/3'

        return <div className={`${window.location.pathname.includes('editor') && (["dt", "mob"].filter((i) => i === this.props.visibility).length) ? 'opacity-50' : this.props.visibility == "dt" ? 'hidden lg:flex' : this.props.visibility == "mob" ? 'lg:hidden' : ''} bg-${this.props.backgroundColor}`}>
                <div className="container">
                    <div className="flex flex-wrap w-full">
                        <div className="flex md:hidden w-full">
                            <div className="w-full p-[10px]">
                                {items.map((i, index) => this.loadItem(i, index))}
                            </div>
                        </div>
                        <div className="hidden md:flex md:w-full">
                            {boundaries.slice(0, -1).map((start, i) => (
                                <div key={i} className={`${colWidth} p-[10px]`}>
                                    {items.slice(start, boundaries[i + 1]).map((item, j) => this.loadItem(item, start + j))}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
    }
}

ColumnsMasonry.defaultProps = {
    visibility: "",
    backgroundColor: 'white-50',
    columnLength: 3,
    spacing: [],
    columns: [{cardBackgroundColor: 'neutral-stone-500', content: [], cardHeight:"250px"}, {cardBackgroundColor: 'neutral-stone-500', content: [] , cardHeight:"250px"}, {cardBackgroundColor: 'neutral-stone-500', content: [] , cardHeight:"250px"}, {cardBackgroundColor: 'neutral-stone-500', content: [] , cardHeight:"250px"}, {cardBackgroundColor: 'neutral-stone-500', content: [] , cardHeight:"250px"}, {cardBackgroundColor: 'neutral-stone-500', content: [] , cardHeight:"250px"}],
}

ColumnsMasonry.fields = {
    backgroundColor: {
        type: "select",
        options: Opt.colorVariables
    },
    visibility: {
        type: "select",
        options: Opt.visibilityOptions
    },
    columnLength: {
        type: "radio",
        options: [
            { label: "Two", value: 2 },
            { label: "Three", value: 3 },
        ],
    },
    spacing: Opt.spacingOptions,
    "0":{type:"slot"},
    "1":{type:"slot"},
    "2":{type:"slot"},
    "3":{type:"slot"},
    "4":{type:"slot"},
    "5":{type:"slot"},
    "6":{type:"slot"},
    "7":{type:"slot"},
    "8":{type:"slot"},
    "9":{type:"slot"},
    "10":{type:"slot"},
    "11":{type:"slot"},
    "12":{type:"slot"},
    columns: {
        type: "array",
        arrayFields: {
            name: {
                type: "text"
            },
            cardBackgroundColor: {
                type: "custom",
                render: (props) => <ColorSelector {...props} />
            },
            backgroundImage: {
                type: "custom",
                render: ({ name, onChange, value }) => <MediaSelector name={name} type={'img'} onChange={onChange} value={value} />,
            },
            cardHeight: {
                type: "text",
            },
        },
        defaultItemProps: { cardBackgroundColor: 'neutral-stone-500', content: [], cardHeight:"250px"},
        getItemSummary: (col, i) => col.name ? `${col.name} #${i+1}` : `Column #${i+1}`,
    }
}

export default ColumnsMasonry;